import { BlikErrorCodes } from 'consts';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { IError } from 'types/Payment';

import { Icon, ReasonContainer, TitleContainer } from './BlikError.styles';

const { AUTHORIZATION_CODE_EXPIRED, AUTHORIZATION_CODE_INVALID, AUTHORIZATION_CODE_USED } = BlikErrorCodes;

export default memo(({ errors }: { errors: IError[] }) => {
  let title = '';
  let reason = '';

  const error = errors[0] && errors[0].errorType;

  switch (error) {
    case AUTHORIZATION_CODE_EXPIRED:
      title = 'blik.error.ticketExpired.title';
      reason = 'blik.error.ticketExpired.reason';
      break;
    case AUTHORIZATION_CODE_USED:
      title = 'blik.error.ticketUsed.title';
      reason = 'blik.error.ticketUsed.reason';
      break;
    case AUTHORIZATION_CODE_INVALID:
      title = 'blik.error.wrongTicket.title';
      reason = 'blik.error.wrongTicket.reason';
      break;
    default:
      title = 'blik.error.otherError.title';
      reason = 'blik.error.otherError.reason';
  }

  return (
    <>
      <TitleContainer className="blik-error__title">
        <Icon />
        <FormattedMessage id={title} />
      </TitleContainer>
      <ReasonContainer className="blik-error__reason">
        <FormattedMessage id={reason} />
      </ReasonContainer>
    </>
  );
});
